import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Configurable admin path from .env (REACT_APP_ADMIN_PATH)
const adminPath = process.env.REACT_APP_ADMIN_PATH || '/admin';
const isAdminRoute = window.location.pathname.startsWith(adminPath);

if (isAdminRoute) {
  // Unregister service worker on admin routes so the admin app loads from server
  serviceWorkerRegistration.unregister();
} else {
  serviceWorkerRegistration.register();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
